// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__06wIC","modal":"Modal_modal__KecoU","slide-down":"Modal_slide-down__YR+Jy"};